import React from "react";
import { Outlet } from "react-router-dom";

const SeriesIndex = () => {

  return (
    <div>
      <Outlet />
    </div>
  );
};

export default SeriesIndex;
